export const GITHUB_AUTH_TOKEN = `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`;
